import React from 'react';
import { Link, withRouter } from 'react-router';
import { connect } from 'react-redux';

import { loadEvent } from 'dash-front/components/sm/pages/actions';
import { EventHeader } from '../../EventCell';
import styled from 'styled-components';
import _ from 'lodash';

let eventLink = (e, action) =>
    `/sm/browser/football/tournaments/${e.tournamentTemplateId}/${e.tournamentId}/stages/${
        e.tournamentStageId
    }/rounds/${encodeURIComponent(e.properties.round)}/events/${e.eventId}/${action}`;

const EventHeaderEnhanced = connect(state => ({
    event: state.smBrowser.event
}))(EventHeader);

let Enav = styled.p`
    a {
        margin: 5px 10px;
        padding: 0px 10px;
        line-height: 32px;
        display: inline-block;
    }
    a.active {
        background: #3f51b5;
        color: #fff;

        border-radius: 16px;
    }
`;

class EventSMB extends React.Component {
    constructor(props, context) {
        super(props, context);
    }

    componentDidMount = () => {
        let {
            params: { eventId },
            dispatch,
            loadEvent
        } = this.props;

        dispatch(loadEvent(eventId));
    };

    componentWillReceiveProps = nextProps => {
        let {
            params: { eventId },
            dispatch,
            loadEvent
        } = this.props;

        if (+eventId !== +nextProps.params.eventId) {
            dispatch(loadEvent(+nextProps.params.eventId));
        }
    };

    state = {};

    render() {
        let {
            event,

            router
        } = this.props;

        if (!event) return <div />;
        return (
            <div>
                <EventHeaderEnhanced />
                <Enav style={{ textAlign: 'center' }}>
                    {_.toPairs({
                        home: 'Home',
                        lineup: 'Lineups',
                        incidents: 'Incidents',
                        bookie: 'Bookie',
                        stats: 'Team stats',
                        'best-players': 'Player performance'
                    }).map(([url, label]) => (
                        <Link
                            key={label}
                            className={router.isActive(eventLink(event, url)) && 'active'}
                            to={eventLink(event, url)}
                        >
                            {label}
                        </Link>
                    ))}
                </Enav>
                {this.props.children}
            </div>
        );
    }
}

export default connect(
    state => ({
        event: state.smBrowser.event
    }),
    dispatch => ({
        dispatch,
        loadEvent
    })
)(withRouter(EventSMB));



/** WEBPACK FOOTER **
 ** ../src/dash/front/components/sm/pages/event/EventHost.js
 **/